import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDashboardPDF } from 'interfaces/store/dashboardPDF';

const initialState: IDashboardPDF = {
  loading: false,
  generatingPDF: false,
  downloadIndex: 0
};

const dashboardPDFSlice = createSlice({
  name: 'downloadPdf',
  initialState: initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setGeneratingPDF(state, action: PayloadAction<boolean>) {
      state.generatingPDF = action.payload;
    },
    setDownloadIndex(state, action: PayloadAction<number>) {
      state.downloadIndex = action.payload;
    }
  }
});

export const { setLoading, setGeneratingPDF, setDownloadIndex } =
  dashboardPDFSlice.actions;

export default dashboardPDFSlice.reducer;
